// api.js

import axios from 'axios'
import { Response, queryParam } from './_model'
import { ClientModel } from '@velocity/shared'

const BASE_URL = process.env.REACT_APP_BASE_URL

export const locations_api = async (
  data: queryParam
): Promise<Response<ClientModel[]>> => {
  return await axios.get(`${BASE_URL}/location?${data.queryKey[1] || ''}`)
}
export const location_api = async (data: queryParam): Promise<ClientModel> => {
  return await axios.get(
    `${BASE_URL}/location/${data.queryKey[1]}?${data.queryKey[2] || ''}`
  )
}

export const create_location_api = async (data: ClientModel) => {
  return await axios.post(`${BASE_URL}/location`, data)
}

export const update_location_api = async (data: ClientModel) => {
  return await axios.put(`${BASE_URL}/location/${data.id}`, data)
}

export const delete_location_api = async (data: string | string[]) => {
  return await axios.delete(`${BASE_URL}/location/${data}`)
}
